export const FONT_FAMILIES = [
  'Arial',
  'Helvetica',
  'Verdana',
  'Tahoma',
  'Trebuchet MS',
  'Times New Roman',
  'Georgia',
  'Garamond',
  'Palatino',
  'Bookman',
  'Courier New',
  'Lucida Console',
  'Monaco',
  'Consolas',
  'Impact',
  'Comic Sans MS',
  'Segoe UI',
  'Roboto',
  'Open Sans',
  'Lato',
  'Montserrat',
  'Oswald',
  'Merriweather',
  'Fira Sans',
  'Inter',
  'Source Sans Pro',
  'PT Sans',
  'Noto Sans',
  'Ubuntu',
  'Calibri',
  'Candara',
  'Optima',
  'Century Gothic',
  'Franklin Gothic Medium',
  'Geneva',
  'Arial Black',
  'Brush Script MT',
];